'use strict';

(function () {

  angular
    .module('specsguardApp')
    .service('Session', Session);

  Session.$inject = ['$cookies'];

  function Session ($cookies) {
    // FAKE SESSION REFERRER

    this.referrer = '';

    this.hasReferrer = function () {
      return this.referrer !== '';
    };

    this.setReferrer = function (value) {
      var _this = this;
      _this.referrer = value;
    };

    this.getReferrer = function () {
      const _this = this;
      if (angular.isDefined(_this.referrer)) {
        const tempReferrer = _this.referrer;
        this.referrer = '';
        return tempReferrer;
      }
      throw new Error('No referrer set !');
    };

    // REAL SESSION SAVE / LOAD STRING

    this.saveString = function (sessionKey, value) {
      // $log.debug('Session saveString: ', value)
      $cookies.put(sessionKey, value);
    };

    this.loadString = function (sessionKey) {
      const value = $cookies.get(sessionKey);
      // $log.debug('Session loadString with sessionKey: ', sessionKey, ' = ', value)
      return value;
    };
  }

})();
